import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/core/estatos_civis${queryUrl}`)
  },
  insertNewCivilStatus(data) {
    return axios.post('/core/estatos_civis', data)
  },
  editCivilStatus(data) {
    return axios.put(`/core/estatos_civis/${data.id}`, data)
  },
  deleteCivilStatus(id) {
    return axios.delete(`/core/estatos_civis/${id}`)
  },
}
